import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import { action, observable, runInAction } from 'mobx';
import { FormattedMessage } from 'ui/i18n';

import { InfoBox } from 'ui/components';

import './SelfClosingPopup.scss';

const POP_UP_LIFETIME = 5000;

@observer
export default class SelfClosingPopup extends Component {
	static propTypes = {
		show: PropTypes.bool.isRequired,
		content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
		fullScreen: PropTypes.bool,
		onRequestClose: PropTypes.func,
		className: PropTypes.string,
	};

	static defaultProps = {
		content: '',
		fullScreen: false,
		onRequestClose: () => true,
		className: '',
	};

	@action
	componentWillReceiveProps(props) {
		this.toggle = props.show;

		if (this.toggle) {
			this.closeMe();
		}
	}

	@observable toggle = this.props.show;

	@action
	closeMe() {
		setTimeout(() => {
			runInAction(() => {
				this.toggle = false;
				this.props.onRequestClose();
			});
		}, POP_UP_LIFETIME);
	}

	render() {
		const fullScreenClass = this.props.fullScreen ? 'FullScreen' : '';
		const display = this.toggle ? 'SelfClosingPopup__show' : 'SelfClosingPopup';
		return (
			<div className={`${display} ${fullScreenClass}`}>
				<InfoBox type="success" className={this.props.className}>
					<span className="checkmark-icon" />
					{this.props.content
						? this.props.content
						: <span>
								<FormattedMessage id="cart.itemsAddedMessage" />
								<Link to="/cart">
									<FormattedMessage id="cart.viewCartMessage" />
								</Link>
							</span>}
				</InfoBox>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/SelfClosingPopup/index.js